export default __webpack_public_path__ + "static/media/close-filled.41dc156f.svg";